<a routerLink="/" class="logo">

    <div class="logo__image">
        <!-- logo -->

        <img src="assets/images/logo.png" style="width: 261px;">
        <!-- logo / end -->
    </div>
</a>
